import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Button } from '@material-ui/core';

class OverwriteDialog extends Component {
    render() {
        const { classes } = this.props
        return (
            <Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Moving lesson. Do you want to break this lesson from it's parent component?</DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState(this.props.event, true)}
                            >Yes
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.closeDialogState(this.props.event, false)}
                            >No
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
        )
    }
}

export default OverwriteDialog;


// WEBPACK FOOTER //
// src/main/content/company/CompanyCalendar/BreakLessonFromCourseDialog.js